/**
 * Marketing ROI (owner research P0 items 1, 2 and 4): which marketing source
 * brought each new patient, what they produced and collected at 30 / 90 /
 * 365 days, against the ad spend the office enters, plus the tracking-number
 * and DNI config. One page with tabs; its sidebar home is Practice, next to
 * Analytics, and Velora Modern lists it under Office Manager.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'growth',
    title: 'Marketing ROI',
    version: '0.1.0',
    owner: 'WP3-GROWTH',
    entitlementKey: null,
    permissions: ['reports.view', 'money.view', 'settings.manage', 'patient.edit'],
    routes: [
      {
        id: 'roi',
        path: '/growth',
        title: 'Marketing ROI',
        permission: 'reports.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Marketing ROI',
        group: 'analytics',
        routeId: 'roi',
        icon: 'trending-up',
        order: 15,
        permission: 'reports.view',
      },
    ],
    commands: [
      {
        id: 'growth.open',
        title: 'Go to Marketing ROI',
        keywords: [
          'marketing',
          'roi',
          'roas',
          'ad spend',
          'new patient source',
          'referral source',
          'cost per new patient',
          'tracking numbers',
          'call tracking',
          'dni',
        ],
        routeId: 'roi',
        permission: 'reports.view',
      },
    ],
    phiReadPoints: ['growth.acquisitions', 'growth.acquisition'],
  }),
  pages: {
    roi: () => import('./GrowthPage.js'),
  },
});
